import type {ComponentType} from "react";

import {Link} from "react-router-dom";

import {BuildingIcon, DiscIcon, KeyRoundIcon, NetworkIcon, ZapIcon} from "lucide-react";

import {useAuth} from "@/lib/auth";

import {Card, CardDescription, CardHeader, CardTitle} from "@/components/ui/card";

const tiles: Array<{to: string; title: string; desc: string; icon: ComponentType<{className?: string}>}> = [
  {
    to: "/admin/orgs",
    title: "Organizations",
    desc: "Customer tenants and their API keys.",
    icon: BuildingIcon,
  },
  {
    to: "/admin/lairs",
    title: "Lairs",
    desc: "Hypervisor hosts in the fleet.",
    icon: NetworkIcon,
  },
  {
    to: "/admin/plans",
    title: "Plans",
    desc: "VM plans and pricing.",
    icon: ZapIcon,
  },
  {
    to: "/admin/os-images",
    title: "OS Images",
    desc: "Bootable OS images for new servers.",
    icon: DiscIcon,
  },
  {
    to: "/admin/api-keys",
    title: "Platform API keys",
    desc: "Tenant-less keys (e.g. Blesta module).",
    icon: KeyRoundIcon,
  },
];

export const AdminDashboard = () => {
  const {principal} = useAuth();
  const account = principal?.account;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-semibold">Admin dashboard</h1>
        <p className="text-sm text-muted-foreground">
          Welcome{account ? `, ${account.display_name || account.email}` : ""}.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to} className="group">
            <Card className="transition-colors hover:bg-muted/40">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="flex size-9 items-center justify-center rounded-md bg-primary/10 text-primary">
                    <t.icon className="size-5" />
                  </div>
                  <CardTitle>{t.title}</CardTitle>
                </div>
                <CardDescription className="mt-2">{t.desc}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};
